import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
    message: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.flexDirectionColumn,
        ...theme.mixins.flex.alignItemsCenter,
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        zIndex: 10,
        fontWeight: '450',
        color: theme.palette.text.primary,
        textAlign: 'center',
        fontSize: '14px',
    },
}));

export default function MessageOverlay({ message }) {
    const styles = useStyles();

    return <Typography className={styles.message}>{message}</Typography>;
}
